export default __webpack_public_path__ + "static/4-8f233d3acbdc9ee04031c87fd4d9b8f9.jpeg";